module.exports = __webpack_public_path__ + "static/media/Telegram-bot.b3986815.png";